<section class="section-wrapper">
    <!-- <h2 class="cam-heading" *ngIf="heading">{{content?.['b2b.managetraveler.addnewtraveler']}}</h2> -->
    <h2 class="cam-heading">{{content?.['b2b.managetraveler.travelermanagement']}}</h2>
    <div *ngIf="sidebar && showToastMessage && !!descriptionData">
        <!-- <mat-icon fontSet="material-symbols-outlined" color="primary" aria-label="Info">info</mat-icon>
        Please add and save the traveler's personal information to enable saving other profile details.. -->
        <app-toast-message  [descriptionData]="descriptionData" [toastrClass]="'toast-msg__info-small'"  [Isvisible]="false" ></app-toast-message>
    </div>

    <div class="section-context">
        <div class="menu-left-content">
            <app-menu-nav-traveler></app-menu-nav-traveler>
        </div>
        <div class="right-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</section>